import type { JSX } from 'react';

import { PetitionCard, Text } from '@change/ds-core-ui/next';

import { Translate, useI18n } from '@change-corgi/core/react/i18n';

import type { ImpactPageData } from 'src/app/pages/about/impact/pageContext';

export function TrendingPetitions({
	trendingPetitions,
}: {
	trendingPetitions: ImpactPageData['suggestedPetitions'];
}): JSX.Element | null {
	const { translate, translatePlural } = useI18n();

	if (trendingPetitions.petitions.length === 0) {
		return null;
	}
	return (
		<>
			<Text as="p" size="large" className="mb-10 mt-2 text-center">
				<Translate value="fe.pages.impact.your_voice.description" />
			</Text>
			<div className="grid grid-cols-1 justify-items-center gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
				{trendingPetitions.petitions.map(({ node: petition }) => (
					<PetitionCard
						key={petition.id}
						className="w-full"
						imageUrl={petition.photo?.petitionMedium.url}
						petitionId={petition.id}
						victoryLabel={translate('corgi.components.petition_card.victory')}
						petitionLinkUrl={`/p/${petition.slug}?source_location=impact_page`}
						signaturesLabel={translatePlural(
							'corgi.components.petition_card.signatures',
							petition.signatureState.signatureCount.displayed,
							{
								countLocalized: petition.signatureState.signatureCount.displayedLocalized,
							},
						)}
						title={petition.displayTitle}
					/>
				))}
			</div>
		</>
	);
}
